import React from "react";
import { Box, Grid, Stack, Typography } from "@mui/material";
import { LiveDrawCards } from "../../cards";

import powerballImage from "../../../../../static/Images/powerball.png";
import revolverImage from "../../../../../static/Images/revolver.png";
import mineImage from "../../../../../static/Images/mine.png";

import "../liveGames/liveGames.css";

import { colors } from "../../../../../theme";
// Static placeholder data for live draws
const liveGames = [
  {
    title: "Powerball",
    type: "Lottery",
    roundNumber: "212394",
    numbers: [7, 11, 23, 32, 41, 17],
    countdown: "12 : 24 : 36",
    image: powerballImage,
    accentColor: colors.ribbon.deltaNegative,
  },
  {
    title: "Revolver",
    type: "Spinner",
    roundNumber: "87921",
    countdown: "00 : 04 : 21",
    image: revolverImage,
    accentColor: colors.charts.amber,
  },
  {
    title: "Mine",
    type: "Original",
    roundNumber: "141220",
    countdown: "02 : 15 : 08",
    image: mineImage,
    accentColor: colors.blue[500],
  },
];

const LiveGames = () => {
  return (
    <Box component="section" className="home-live-draws">
      
      {/* Header Section */}
      <Stack className="live-draws-header" direction="row" alignItems="flex-end" justifyContent="space-between">
        <Box>
          <Typography component="p" className="live-draws-eyebrow">
            LIVE DRAWS
          </Typography>
          <Typography component="h2" className="live-draws-title">
            Live & Transparent
          </Typography>
        </Box>

        <Typography component="a" href="/all-lottery" className="live-draws-link">
          View All Draws
        </Typography>
      </Stack>

      {/* Live Draw Cards Grid */}
      <Grid container spacing={3} className="live-draws-grid">
        {liveGames.map((game) => (
          <Grid item xs={12} md={4} key={game.title} className="live-draw-card-wrapper">
            <LiveDrawCards
              image={game.image}
              title={game.title}
              type={game.type}
              roundNumber={game.roundNumber}
              numbers={game.numbers}
              countdown={game.countdown}
              accentColor={game.accentColor}
            />
          </Grid>
        ))}
      </Grid>

    </Box>
  );
};

export default LiveGames;